import { render, staticRenderFns } from "./IndustryAverageDropdown.vue?vue&type=template&id=b4d61d78&scoped=true&"
import script from "./IndustryAverageDropdown.vue?vue&type=script&lang=ts&"
export * from "./IndustryAverageDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./IndustryAverageDropdown.vue?vue&type=style&index=0&id=b4d61d78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d61d78",
  null
  
)

export default component.exports